import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Este libro me hizo abrir los ojos sobre situaciones que llevaba años justificando.',
    name: 'Carmen R.'
  }, {
    quote: 'Por primera vez entendí que mi valor no depende de la atención de nadie.',
    name: 'Lucía M.'
  }, {
    quote: 'Las reflexiones me ayudaron a volver a conectar conmigo misma.',
    name: 'Andrea G.'
  }, {
    quote: 'Lo recomiendo a cualquier mujer que haya olvidado lo importante que es.',
    name: 'Patricia V.'
  }, {
    quote: 'Un antes y un después en mi forma de ver las relaciones. Ya no acepto menos.',
    name: 'Elena S.'
  }];
  return <section className="w-full bg-white py-16 md:py-24 px-4" data-id="element-162">
      <div className="max-w-4xl mx-auto" data-id="element-163">
        <h2 className="font-serif text-3xl md:text-5xl font-bold text-center text-gray-900 mb-16" data-id="element-164">
          TESTIMONIOS
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-165">
          {testimonials.map((t, i) => <div key={i} className={`bg-brand-cream/30 p-8 rounded-2xl border border-brand-cream shadow-sm ${i === 4 ? 'md:col-span-2 md:w-1/2 md:mx-auto' : ''}`} data-id="element-166">
              <div className="flex gap-1 mb-4 text-brand-yellow" data-id="element-167">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-current" data-id="element-168" />)}
              </div>
              <p className="text-lg text-gray-800 font-medium italic mb-4" data-id="element-169">
                "{t.quote}"
              </p>
              <p className="text-sm text-gray-500 font-bold uppercase" data-id="element-170">
                — {t.name}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}